import request from 'utils/request';
const axios: any = new request('leadbest-official-website').request;

export async function getHomepageNews(payload: any): Promise<any> {
    const { params } = payload
    const { type, selectedTags, page, limit } = params
    const filterType = type && type != "ALL" ? `&filter[category]=${type}` : ""
    return axios.get(`/items/news?fields=*.*.*,cover&limit=3${filterType}&filter[status][_eq]=published&sort=-date_published`);
}

export async function getNews(payload: any): Promise<any> {
    const { params } = payload
    const { type, selectedTags, page, limit } = params
    const filterType = type && type != "ALL" ? `&filter[category]=${type}` : ""
    const filterTags = selectedTags ? `&filter[tags][news_tags_id][name][_in]=${selectedTags}` : ""
    return axios.get(
        `/items/news?fields=*.*,tags.news_tags_id.*&limit=${limit || 8}&meta=filter_count&page=${page}${filterType}${filterTags}&filter[status][_eq]=published&sort=-date_published`);
}

export async function getFeatureNews(payload: any): Promise<any> {
    return axios.get(`/items/featured_news?fields=*.*.*&limit=10&filter[status][_eq]=published`, payload);
}

export async function getTags(payload: any): Promise<any> {
    return axios.get(`/items/news_tags?fields=*.*`, payload);
}

export async function getNewsDetails(payload: any): Promise<any> {
    return axios.get(`/items/news/${payload.id}?fields=*.*.*,tags.news_tags_id.*,related_news.*.*.*.*&deep[related_news][_filter][related_news_id][status][_eq]=published`, payload);
}